import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react'
import AddEditSocialMedia from '../components/AddEditSocialMedia';

const SocialMedia = ({product}) => {
  const [dialog,setDialog]=useState()
  console.log("Allllllllllllllllllllllllllll",product)
  const data = [
    {
      title: "Title 1",
      imageUrl: "assets/layout/images/banner-primeblocks-dark.png"
    },
    {
      title: "Title 2",
      imageUrl: "assets/layout/images/banner-primeblocks-dark.png"
    },
    {
      title: "Title 3",
      imageUrl: "assets/layout/images/banner-primeblocks-dark.png"
      
    },
    // Add more objects as needed
  ];
  const onHide=()=>{
    setDialog(false)
  }

  return (
    <>
        <Dialog visible={dialog} onHide={onHide} header={"Add New"} style={{ width: "70vw" }}>
            <AddEditSocialMedia    />
        </Dialog>
      <div className='grid'>
        <div className="md:col-10"></div>
        <div className='md:col-2'>
          <div >
            <Button className=" p-button custom-bg w100" label="Add New"
              onClick={() => { setDialog(true) }}
            />
          </div>
        </div>

      </div>
      <div className='grid'>
        {data.map((item, index) => (
          <div className="md:col-3" key={index}>
            <div>
              <h6>{item.title}</h6>
              <img src={item.imageUrl} alt="logo" style={{width:'100%'}}/>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default SocialMedia